const enum genderEnum {
    Male = "MALE",
    Female = "FEMALE",
    None = '',
}

export default genderEnum